import { ref } from 'vue';

// Global chat window state
const isChatWindowVisible = ref(false);
const isChatMinimized = ref(false);

export function useChatWindow() {
    const openChatWindow = () => {
        isChatWindowVisible.value = true;
        isChatMinimized.value = false;
    };

    const closeChatWindow = () => {
        isChatWindowVisible.value = false;
        isChatMinimized.value = false;
    };

    const minimizeChatWindow = () => {
        isChatWindowVisible.value = false; // Hide overlay so the page is usable; user can reopen from sidebar
        isChatMinimized.value = true;
    };

    const restoreChatWindow = () => {
        isChatMinimized.value = false;
    };

    const toggleChatWindow = () => {
        if (isChatWindowVisible.value) {
            closeChatWindow();
        } else {
            openChatWindow();
        }
    };

    return {
        // State
        isChatWindowVisible,
        isChatMinimized,
        
        // Actions
        openChatWindow,
        closeChatWindow,
        minimizeChatWindow,
        restoreChatWindow,
        toggleChatWindow
    };
}
